import { render } from "./HdSwatches.vue?vue&type=template&id=3b82c6ee"
import script from "./HdSwatches.vue?vue&type=script&lang=js"
export * from "./HdSwatches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__